import { Checkbox, Flex } from "@chakra-ui/react";
import React from "react";
import CustomHeading from "../../../components/text/CustomHeading";
import CustomText from "../../../components/text/CustomText";

function AboutYou({ payload, setPayload }: any) {
  return (
    <Flex
      flexDir="column"
      gap="22px"
      maxW="666px"
      minH="421px"
      w="100%"
      mx="auto"
    >
      <CustomHeading text="About You" family="aeonik-bold" align="center" />
      <Flex gap="22px">
        <Flex flexDir="column" gap="11px" w="100%">
          <CustomText
            text="Which show features you are interest in?"
            size="12px"
          />
          {[
            "Live demonstrations of advanced military equipment",
            "Showcases of cutting-edge defense technologies",
            "Networking opportunities with global defense leaders",
            "Exhibitions of unmanned aerial vehicles (UAVs) and drones",
            "Panel discussions with industry experts on defense innovation",
            "Workshops on cybersecurity and digital defense strategies",
            "Interactive displays of armored vehicles and tanks",
            "Simulation exercises for emergency and disaster response",
          ]?.map((item: string, index: number) => (
            <Flex
              key={index}
              align="center"
              gap="16px"
              w="100%"
              p="10px 20px"
              borderRadius="4px"
              border="1px solid"
              borderColor="yess.border"
              bg="yess.g1"
              cursor="pointer"
            >
              <Checkbox
                size="lg"
                colorScheme="green"
                isChecked={payload?.interests.includes(item)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setPayload({
                      ...payload,
                      interests: [...payload.interests, item],
                    });
                  } else {
                    setPayload({
                      ...payload,
                      interests: payload.interests.filter(
                        (i: string) => i !== item
                      ),
                    });
                  }
                }}
              />
              <CustomText text={item} size="14px" />
            </Flex>
          ))}
        </Flex>
        <Flex flexDir="column" gap="11px" w="100%">
          <CustomText
            text="What domain you worked in defense Industry?"
            size="12px"
          />
          {[
            "Air",
            "Space",
            "Cyber",
            "Land",
            "Naval",
            "AI & Machine Learning",
            "Blockchain",
            "Communication",
            "Surveillance",
            "Satellite Technology",
          ]?.map((item: string, index: number) => (
            <Flex
              key={index}
              align="center"
              gap="16px"
              w="100%"
              p="10px 20px"
              borderRadius="4px"
              border="1px solid"
              borderColor="yess.border"
              bg="yess.g1"
              cursor="pointer"
            >
              <Checkbox
                size="lg"
                colorScheme="green"
                isChecked={payload?.domainOfWork.includes(item)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setPayload({
                      ...payload,
                      domainOfWork: [...payload.domainOfWork, item],
                    });
                  } else {
                    setPayload({
                      ...payload,
                      domainOfWork: payload.domainOfWork.filter(
                        (i: string) => i !== item
                      ),
                    });
                  }
                }}
              />
              <CustomText text={item} size="14px" />
            </Flex>
          ))}
        </Flex>
      </Flex>
      <Flex gap="22px">
        <Flex flexDir="column" gap="11px" w="100%">
          <CustomText text="How did you learn about event?" size="12px" />
          {[
            "Official website",
            "Social media (Facebook, Twitter, LinkedIn)",
            "Email invitation",
            "Industry newsletter",
            "Colleague or friend",
            "Event flyer or poster",
            "Previous attendee recommendation",
            "Online advertisement",
            "Company or employer notification",
            "Direct invitation from exhibitors",
            "Community or professional forum",
          ]?.map((item: string, index: number) => (
            <Flex
              key={index}
              align="center"
              gap="16px"
              w="100%"
              p="10px 20px"
              borderRadius="4px"
              border="1px solid"
              borderColor="yess.border"
              bg="yess.g1"
              cursor="pointer"
            >
              <Checkbox
                size="lg"
                colorScheme="green"
                isChecked={payload?.aboutEvent.includes(item)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setPayload({
                      ...payload,
                      aboutEvent: [...payload.aboutEvent, item],
                    });
                  } else {
                    setPayload({
                      ...payload,
                      aboutEvent: payload.aboutEvent.filter(
                        (i: string) => i !== item
                      ),
                    });
                  }
                }}
              />
              <CustomText text={item} size="14px" />
            </Flex>
          ))}
        </Flex>
        <Flex flexDir="column" gap="11px" w="100%">
          <CustomText text="What is your purpose of visit?" size="12px" />
          {[
            "Networking with industry professionals",
            "Exploring new products and technologies",
            "Attending keynote presentations and sessions",
            "Seeking business partnerships or collaborations",
            "Gathering market insights and trends",
            "Evaluating potential suppliers or vendors",
            "Representing my company or organization",
            "Meeting with existing clients or partners",
            "Researching for academic or industry purposes",
            "Supporting a colleague or team",
          ]?.map((item: string, index: number) => (
            <Flex
              key={index}
              align="center"
              gap="16px"
              w="100%"
              p="10px 20px"
              borderRadius="4px"
              border="1px solid"
              borderColor="yess.border"
              bg="yess.g1"
              cursor="pointer"
            >
              <Checkbox
                size="lg"
                colorScheme="green"
                isChecked={payload?.purposeOfVisit.includes(item)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setPayload({
                      ...payload,
                      purposeOfVisit: [...payload.purposeOfVisit, item],
                    });
                  } else {
                    setPayload({
                      ...payload,
                      purposeOfVisit: payload.purposeOfVisit.filter(
                        (i: string) => i !== item
                      ),
                    });
                  }
                }}
              />
              <CustomText text={item} size="14px" />
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
}

export default AboutYou;
